<template>
  <DataListStateful
    title="Курьерские службы"
    resource="courier-services"
    store="courierServices"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Название", name: "title", sortable: true },
        {
          title: "Телефон",
          name: "phones",
          type: "text-array-phone",
          sortable: true,
        },
        {
          title: "Email",
          name: "emails",
          type: "text-array",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Контактное лицо",
          name: "contactPerson",
          dataPath: "ContactPerson.Title",
          sortable: true,
        },
        {
          title: "Адрес",
          name: "address",
          dataPath: "Address.Title",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        phone: {
          title: "Телефон",
          type: "text",
        },
        email: {
          title: "Email",
          type: "text",
        },
        contactPerson: {
          title: "Контактное лицо",
          type: "reference",
          resource: "contact-persons",
        },
        address: {
          title: "Адрес",
          type: "reference",
          resource: "addresses",
        },
      },
    };
  },
};
</script>
